import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-modal';

import { DataContext } from '../../context/DataContext';
import { frecuenciaPagos, SAs } from '../../data/mochaData';
import http from '../../services/http';
import { sendNotificationPayByPhone } from '../../services/notifications';
import { calculatePrima } from '../../services/tarificar';
import { ImgAlert, ImgAlertCallCenter, ImgAlertOk, ImgFileDownload } from '../../svg';
import { customStyles, endPoints, monedas } from '../../utils/constanst';
import { twoDecimal } from '../../utils/helpers';

import DivRow from '../controls/DivRow';
import DropDownInput from '../controls/DropDownInput';
import Input from '../controls/Input';

import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';
import Pasarela from './Pasarela';

import ReCAPTCHA from "react-google-recaptcha";
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import DebitoAutomatico from '../controls/DebitoAutomatico';

const DebitoAutomaticoWrapper = () => {



    const { poliza, setPoliza, changeHandler } = useContext(CotizadorCRDataContext);

    useEffect(() => {
            setTimeout(() => {
                const preloader = document.querySelector('.site-preloader');

                if (preloader) {
                    preloader.addEventListener('transitionend', (event) => {
                        if (event.propertyName === 'opacity') {
                            preloader.parentNode.removeChild(preloader);
                        }
                    });
                    preloader.classList.add('site-preloader__fade');
                }
            }, 600);

    }, [0]);

    useEffect(() => {
        console.log(poliza)

})

    return (
        <div>
            <DebitoAutomatico aseguradoId={poliza.aseguradoId}
                transactionId={poliza.transactionId}
                cnpoliza={poliza.cnpoliza}
                reference={poliza.reference}
                direccion={poliza.direccion}
                direccionCobro={poliza.direccionCobro}
                pais={506}
                datosTarjeta={poliza.pasarela} />

        </div>
    );
}

export default DebitoAutomaticoWrapper;
